import React, { useState } from 'react';
import { useRouter } from 'next/router';

import './CommunityTopicList.scss';
import { timeSince } from '../../../helpers/date';
import Popup from '../../redesign/Popup/Popup.jsx';
import { getString } from '../../../helpers/styles';
import Transition from '../../Transition/Transition.jsx';
import icons from '../../../shared/assets/icons/redesign';
import CommunityLeaveGroupPopupContent from '../../redesign/PopupContent/CommunityLeaveGroupPopupContent/CommunityLeaveGroupPopupContent.jsx';
import CommunityFilterTopicPopupContent from '../../redesign/PopupContent/CommunityFilterTopicPopupContent/CommunityFilterTopicPopupContent.jsx';

const { Logout, Filter, ChevronRight, Lock, Pin } = icons;

const sortTypes = [
  'Meest recente activiteit boven',
  'Nieuwste onderwerp boven',
  'Meeste reacties boven'
];

export default function CommunityTopicList({ list, group, userLeaveGroup }) {
  const router = useRouter();
  const [filterPopup, showFilterPopup] = useState(false);
  const [leaveGroupPopup, showLeaveGroupPopup] = useState(false);

  const [sortType, setSortType] = useState(sortTypes[0]);

  return (
    <div className="communityTopicList">
      <div className="communityTopicList-header">
        <h2 className="communityTopicList-header-title">
          Onderwerpen in groep
        </h2>

        <div className="communityTopicList-header-icons">
          <Filter
            onClick={() => showFilterPopup(true)}
            className="communityTopicList-header-icon"
          />
          <Logout
            onClick={() => showLeaveGroupPopup(true)}
            className="communityTopicList-header-icon"
          />
        </div>
      </div>

      <ul className="communityTopicList-body">
        {sortList(sortType).map((topic) => {
          const topicIsPrivate = topic.visibility !== 'PUBLIC';
          const topicIsPinned = topic.pinned === 'Y';

          const topicMostRecentCommentDate = topic.events.length
            ? new Date(
                Math.max.apply(
                  null,
                  topic.events.map(
                    ({ createdAt, updatedAt }) =>
                      new Date(updatedAt || createdAt)
                  )
                )
              )
            : new Date(topic.createdAt);

          return (
            <li
              key={topic.xuid}
              className="communityTopicList-item"
              onClick={() =>
                router.push({
                  pathname: '/community/[groupName]/[topicName]',
                  query: {
                    groupName: group.uri,
                    topicName: topic.subject.toLowerCase()
                  }
                })
              }
            >
              <div className="communityTopicList-item-data">
                <div
                  data-id={topic.xuid}
                  className={getString([
                    {
                      value: 'communityTopicList-item-marker',
                      condition: true
                    },
                    {
                      value: 'communityTopicList-item-marker-active',
                      condition:
                        !topic.follow ||
                        new Date(topic.follow.lastSeenAt) <
                          topicMostRecentCommentDate
                    }
                  ])}
                >
                  &#8226;
                </div>

                <div>
                  <p className="communityTopicList-item-subject">
                    {topic.subject}
                  </p>

                  <p className="userInbox-list-item-comments-data">
                    {`${timeSince(topicMostRecentCommentDate)}, ${
                      topic.events.length
                    } ${topic.events.length > 1 ? 'berichten' : 'bericht'}`}
                  </p>
                </div>
              </div>

              <div className="communityTopicList-item-icons">
                {topicIsPrivate && (
                  <Lock
                    className="
                    communityTopicList-item-icon
                    communityTopicList-item-lock-icon"
                  />
                )}

                {topicIsPinned && (
                  <Pin className="communityTopicList-item-icon" />
                )}

                <ChevronRight className="communityTopicList-item-icon" />
              </div>
            </li>
          );
        })}
      </ul>

      <Transition on={leaveGroupPopup}>
        <div className="popup-wrapper">
          <Popup onClose={() => showLeaveGroupPopup(false)}>
            <CommunityLeaveGroupPopupContent
              group={group}
              userLeaveGroup={userLeaveGroup}
            />
          </Popup>
        </div>
      </Transition>

      <Transition on={filterPopup}>
        <div className="communityTopicList-filter-popup">
          <CommunityFilterTopicPopupContent
            sortType={sortType}
            sortTypes={sortTypes}
            setSortType={setSortType}
            onClose={() => showFilterPopup(false)}
          />
        </div>
      </Transition>
    </div>
  );

  function sortList(type) {
    const { pinnedList, unPinnedList } = list.reduce(
      (obj, item, idx) => {
        if (item.pinned === 'Y') obj.pinnedList.push(item);
        else obj.unPinnedList.push(item);

        return obj;
      },
      { pinnedList: [], unPinnedList: [] }
    );

    switch (type) {
      case sortTypes[0]: {
        return [
          ...pinnedList.sort(mostRecentActivity),
          ...unPinnedList.sort(mostRecentActivity)
        ];
      }

      case sortTypes[1]:
        return [
          ...pinnedList.sort(mostRecentTopic),
          ...unPinnedList.sort(mostRecentTopic)
        ];

      case sortTypes[2]: {
        return [
          ...pinnedList.sort(mostCommentCount),
          ...unPinnedList.sort(mostCommentCount)
        ];
      }
    }

    function mostRecentActivity(a, b) {
      return (
        new Date(
          Math.max.apply(null, [
            new Date(b.createdAt),
            ...b.events.map(
              ({ createdAt, updatedAt }) => new Date(updatedAt || createdAt)
            )
          ])
        ) -
        new Date(
          Math.max.apply(null, [
            new Date(a.createdAt),
            ...a.events.map(
              ({ createdAt, updatedAt }) => new Date(updatedAt || createdAt)
            )
          ])
        )
      );
    }

    function mostRecentTopic(a, b) {
      return new Date(`${b.createdAt}Z`) - new Date(`${a.createdAt}Z`);
    }

    function mostCommentCount(a, b) {
      return (
        b.events.reduce((count, event) => count + event.reactions.length, 0) -
        a.events.reduce((count, event) => count + event.reactions.length, 0)
      );
    }
  }
}
